import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LazyLoading from "./LazyLoading/LazyLoading";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LazyLoading />; // или спиннер
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
